exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".main-notification{position:absolute;top:20px;width:100%}:host ::ng-deep .title-container{padding-top:25px !important}", ""]);

// exports
